import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetApplicationSettings = () =>
  useMutation({
    mutationFn: () => client(`common/applicationsettings`),
  });
